import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import Picker from '@emoji-mart/react';
import EmotionLineIcon from 'remixicon-react/EmotionLineIcon';
import { Popover } from '@tribeplatform/react-ui-kit/Popover';
import { useI18n } from '../../i18n';
import { ComposerIconButton } from './ComposerIconButton';
export const EmojiPickerButton = ({ editor, size, }) => {
    const intl = useI18n();
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
    const onSelectEmoji = useCallback(emoji => {
        const position = {
            from: editor.state.selection.from,
            to: editor.state.selection.to,
        };
        editor
            .chain()
            .focus()
            .insertContentAt(position, [
            {
                type: 'text',
                text: emoji.native,
            },
            {
                type: 'text',
                text: ' ',
            },
        ])
            .run();
        setIsEmojiPickerOpen(false);
    }, [editor]);
    const activator = (_jsx(ComposerIconButton, { icon: EmotionLineIcon, "aria-label": intl.$t({
            id: 'Generics.Emoji',
            defaultMessage: 'Emoji',
        }), size: size, onClick: () => setIsEmojiPickerOpen(!isEmojiPickerOpen) }, void 0));
    return (_jsx(Popover, { placement: "top-start", activator: activator, open: isEmojiPickerOpen, onClose: () => setIsEmojiPickerOpen(false), children: _jsx(Picker, { onEmojiSelect: onSelectEmoji, theme: "light", skinTonePosition: "none", previewPosition: "none" }, void 0) }, void 0));
};
//# sourceMappingURL=EmojiPickerButton.js.map